import React from "react";
import {
  Box,
  Container,
  Grid,
  Skeleton,
  Stack,
  Paper,
  Divider,
} from "@mui/material";

const DashboardSkeleton = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "#f4f6f8",
      }}
    >
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        {/* TITULO E BOTÕES SKELETON */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 4 }}
          spacing={2}
        >
          <Box sx={{ width: { xs: "100%", sm: "300px" } }}>
            <Skeleton variant="text" width="60%" height={40} />
            <Skeleton variant="text" width="90%" height={20} />
          </Box>
          <Stack direction="row" spacing={2}>
            <Skeleton
              variant="rectangular"
              width={130}
              height={40}
              sx={{ borderRadius: 2 }}
            />
            <Skeleton
              variant="rectangular"
              width={130}
              height={40}
              sx={{ borderRadius: 2 }}
            />
          </Stack>
        </Stack>

        {/* CARDS DE MÉTRICAS SKELETON */}
        <Grid container spacing={3} sx={{ mb: 5 }}>
          {[1, 2, 3, 4].map((i) => (
            <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={i}>
              <Paper
                elevation={0}
                sx={{ p: 3, border: "1px solid #e0e0e0", borderRadius: 4 }}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  <Skeleton
                    variant="rounded"
                    width={48}
                    height={48}
                    sx={{ borderRadius: 3 }}
                  />
                  <Box sx={{ flexGrow: 1 }}>
                    <Skeleton variant="text" width="40%" />
                    <Skeleton variant="text" width="70%" height={30} />
                  </Box>
                </Stack>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={3}>
          {/* LISTA DE CLIENTES SKELETON */}
          <Grid item size={{ xs: 12, md: 7 }}>
            <Paper elevation={0} sx={{ p: 3, border: "1px solid #e0e0e0" }}>
              <Skeleton variant="text" width="40%" height={30} sx={{ mb: 2 }} />
              <Divider sx={{ mb: 2 }} />
              {[1, 2, 3, 4].map((item) => (
                <Box
                  key={item}
                  sx={{
                    py: 1.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    sx={{ width: "100%" }}
                  >
                    <Skeleton variant="circular" width={40} height={40} />
                    <Box sx={{ flexGrow: 1 }}>
                      <Skeleton variant="text" width="50%" />
                      <Skeleton variant="text" width="30%" />
                    </Box>
                  </Stack>
                  <Skeleton variant="text" width="50px" />
                </Box>
              ))}
            </Paper>
          </Grid>

          {/* CARD LATERAL SKELETON */}
          <Grid item size={{ xs: 12, md: 5 }}>
            <Paper elevation={0} sx={{ p: 3, border: "1px solid #e0e0e0" }}>
              <Skeleton variant="text" width="60%" height={30} sx={{ mb: 3 }} />
              <Stack spacing={2}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={80}
                  sx={{ borderRadius: 2 }}
                />
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={80}
                  sx={{ borderRadius: 2 }}
                />
              </Stack>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default DashboardSkeleton;
